import React, { useEffect, useState } from 'react';

import { LoadingState } from '../../../shared/components';
import { getIdentityProviders } from '../../../shared/data-sources';
import { type IdentityProvider } from '../../../shared/types';
import { useInvertedLocalize } from '../../../shared/utils/localization';

import SSOEmptyState from './SSOEmptyState';
import SSOTabView from './SSOTabView';

/** SSO Provider Page */
export function SSOListPage(): JSX.Element {
  const l = useInvertedLocalize();
  const [providers, setProviders] = useState<IdentityProvider[] | null>(null);
  const [isLoading, setIsLoding] = useState(true);
  const [isError, setIsError] = useState(false);

  const loadProviders = () => {
    setIsLoding(true);
    setIsError(false);
    getIdentityProviders()
      .then((data) => {
        setProviders(data);
      })
      .catch(() => {
        setIsError(true);
      })
      .finally(() => {
        setIsLoding(false);
      });
  };

  useEffect(() => {
    loadProviders();
  }, []);

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError || !providers) {
    return <>{l('Something went wrong. Please try again later.')}</>;
  }

  if (providers.length === 0) {
    return <SSOEmptyState reloadProviders={loadProviders} />;
  }

  return <SSOTabView providers={providers} reloadProviders={loadProviders} />;
}
